import { ArcClaimDto, ArcDto, translateDateToCurrentTimezone } from 'booksprout'

/**
 * The parts of the old `ArcService` that more than one of its three replacements needs.
 *
 * `getArcResult` and `getClaimResult` post-process what the api returns — dates into `Date`, an empty
 * `reviewFlags` into 0, the pen name lifted onto the arc — and every lane that reads an arc or a claim
 * runs its payload through them. `countSiteFlags` counts set bits in a review-site bitmask.
 *
 * All three are pure. Nothing here talks to apollo, axios or a store.
 */

const getArcResult = (arc: ArcDto | undefined): ArcDto | null => {
  if (arc === void 0 || arc === null) return null

  return {
    ...arc,
    bookId: arc.book?.id,
    arcTeamId: arc.arcTeam?.id,
    book: arc.book,
    arcTeam: arc.arcTeam,
    liveDate: arc.liveDateStr
      ? translateDateToCurrentTimezone(arc.liveDateStr + '')
      : void 0,
    stopDownloadDate: arc.stopDownloadDateStr
      ? translateDateToCurrentTimezone(arc.stopDownloadDateStr + '')
      : void 0,
    dueDate: arc.dueDateStr
      ? translateDateToCurrentTimezone(arc.dueDateStr + '')
      : void 0,
    dueCutOffDate: arc.dueCutOffDateStr
      ? translateDateToCurrentTimezone(arc.dueCutOffDateStr + '')
      : void 0
  }
}

const getClaimResult = (claim: ArcClaimDto | undefined): ArcClaimDto | undefined => {
  if (claim === void 0 || claim === null) return void 0

  return {
    ...claim,
    stopDownloadDate: claim.stopDownloadDate ? translateDateToCurrentTimezone(claim.stopDownloadDate + '') : void 0,
    dueDate: translateDateToCurrentTimezone(claim.dueDate + '')
  }
}

const countSiteFlags = (flags: number | undefined): number => {
  if (!flags) return 0
  return flags.toString(2).replace(/0/g, '').length
}

export { getArcResult, getClaimResult, countSiteFlags }
